import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";

import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";

import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import UpdatePopUp from "./UpdatePopUp";
import nodeinstance from "../../../../../nodeInstance";

export default function ListBaladiyaUpdate({
  token,
  titles = [],
  // updateData,
  setIndex,
}) {
  const [list, setList] = useState([]);

  const [Popup, setPopUp] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});

  //filter
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");

  const getDataByFilter = async () => {
    try {
      const reqObj = {
        visa_provider: selectVisaProvider,
        client: selectedStatus,
      };
      const response = await nodeinstance.post(
        `/baladiya/getBaladiyaByFilter`,
        reqObj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setList(response.data.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  const updateData = () => {
    getDataByFilter();
  };
  useEffect(() => {
    if (selectedStatus != "" || selectVisaProvider != "") {
      getDataByFilter();
    } else {
      console.log("ppppppp.....print....");
    }
  }, [selectedStatus, selectVisaProvider]);

  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list || []);

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    console.log("Selected Client:", clientStatus);
    setSelectedStatus(clientStatus);
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Visa Provider:", visaProvider);
    setSelectVisaProvider(visaProvider);
  };

  const [listData, SetListData] = useState([]);

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    SetListData((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };

  const apiCall = () => {
    setCheckedItems({});
    updateData("");
    setIndex(1);
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };
  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => popOpen()}
        >
          <p>Update Baladiya Location</p>
        </button>
        <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        />
        <FilterDropDown
          onChange={visaProviderFilter}
          title={"Visa Provider"}
          url={`/sadaad/visa-providers/`}
          token={token}
          selectedStatus={selectVisaProvider}
        />
        <FilterDropDown
          onChange={onChangeValue}
          title={"Client"}
          url={`/sadaad/clients`}
          token={token}
          selectedStatus={selectedStatus}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[2600px]">
            <div className="grid grid-cols-table-baladiya-update gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-baladiya-update gap-5 p-6 bg-white text-center">
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.actual_profession || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_professions || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.sponsor_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.baladiya_location || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.baladiya_apply_date || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.baladiya_issue_date || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.baladiya_expiry_date || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.baladiya_valid_days || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.baladiya_status || "-"}
                      />
                    </p>
                    {selectedStatus !== "" &&
                    list.baladiya_status_value === 1 &&
                    selectVisaProvider !== "" ? (
                      <div className="">
                        <input
                          disabled={
                            list.baladiya_status === "Baladiya Location Updated"
                              ? true
                              : false
                          }
                          key={list.employee_id} // Use a unique identifier as the key
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id, list)
                          }
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    {/* <div className="flex items-center mb-0  ">
                    <input
                      disabled={
                        list.baladiya_status === "Baladiya Location Updated"
                          ? true
                          : false
                      }
                      key={list.employee_id} // Use a unique identifier as the key
                      type="checkbox"
                      checked={checkedItems[list.employee_id] || false}
                      onChange={(event) =>
                        handleCheckboxChange(event, list.employee_id)
                      }
                    />
                  </div> */}

                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
          </div>
        </div>
      </div>

      <Pagination />

      {Popup ? (
        <UpdatePopUp
          list={listData}
          data={Popup}
          setPopUp={setPopUp}
          onSuccess={apiCall}
          flage={true}
          updateData={updateData}
        />
      ) : (
        ""
      )}
    </>
  );
}
